/*
  Momento calendar kit — shared helpers for the cal-* sections.
  Date grids match the printed calendars: weeks start on Monday, days from the
  months either side are greyed, and Australian public holidays are named in gold
  (same marked set as the Printbox calendar data).
*/
(function () {
  if (window.MomentoCal) return;

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DOW = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  // Anonymous Gregorian algorithm
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }

  var cache = {};
  function holidays(y) {
    if (cache[y]) return cache[y];
    var H = {};
    function key(dt) { return (dt.getMonth() + 1) + '-' + dt.getDate(); }
    function add(dt, name) { if (dt.getFullYear() === y && !H[key(dt)]) H[key(dt)] = name; }
    function D(m, d) { return new Date(y, m - 1, d); }
    function plus(dt, n) { return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + n); }
    function weekendShift(dt) { var w = dt.getDay(); return w === 6 ? plus(dt, 2) : w === 0 ? plus(dt, 1) : null; }

    var s;
    add(D(1, 1), "New Year's Day");
    if ((s = weekendShift(D(1, 1)))) add(s, "New Year's Day holiday");
    add(D(1, 26), 'Australia Day');
    if ((s = weekendShift(D(1, 26)))) add(s, 'Australia Day holiday');
    var e = easter(y);
    add(plus(e, -2), 'Good Friday');
    add(plus(e, -1), 'Easter Saturday');
    add(e, 'Easter Sunday');
    add(plus(e, 1), 'Easter Monday');
    add(D(4, 25), 'ANZAC Day');
    var june1 = D(6, 1);
    add(plus(june1, ((8 - june1.getDay()) % 7) + 7), "King's Birthday");
    add(D(12, 25), 'Christmas Day');
    add(D(12, 26), 'Boxing Day');
    var xmas = D(12, 25).getDay();
    if (xmas === 6) { add(D(12, 27), 'Christmas Day holiday'); add(D(12, 28), 'Boxing Day holiday'); }
    else if (xmas === 0) { add(D(12, 27), 'Christmas Day holiday'); }
    else if (xmas === 5) { add(D(12, 28), 'Boxing Day holiday'); }

    cache[y] = H;
    return H;
  }

  function holidayOn(dt) {
    return holidays(dt.getFullYear())[(dt.getMonth() + 1) + '-' + dt.getDate()] || null;
  }

  // m is 0-based and may run past 11 (13 = February next year)
  function normalise(y, m) { var d = new Date(y, m, 1); return { y: d.getFullYear(), m: d.getMonth() }; }

  function monthCells(y, m, fixedRows) {
    var n = normalise(y, m); y = n.y; m = n.m;
    var lead = (new Date(y, m, 1).getDay() + 6) % 7;
    var days = new Date(y, m + 1, 0).getDate();
    var total = fixedRows ? 42 : Math.ceil((lead + days) / 7) * 7;
    var out = [];
    for (var i = 0; i < total; i++) {
      var dt = new Date(y, m, 1 - lead + i);
      var inMonth = dt.getMonth() === m;
      out.push({
        day: dt.getDate(),
        inMonth: inMonth,
        dow: i % 7,
        weekend: i % 7 >= 5,
        holiday: inMonth ? holidayOn(dt) : null,
        date: dt
      });
    }
    return out;
  }

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /*
    Date grid markup. opts:
      dow: 'long' | 'short' | 'both' | 'initial' | false   ('both' prints long and short names for CSS to pick)
      names: true to print holiday names under the date
      header: true to add the month + year header
  */
  function gridHTML(y, m, opts) {
    opts = opts || {};
    var n = normalise(y, m);
    var cells = monthCells(n.y, n.m, opts.fixedRows);
    var html = '<div class="mcal" data-rows="' + (cells.length / 7) + '">';
    if (opts.header) {
      html += '<div class="mcal__head"><span class="mcal__month">' + MONTHS[n.m] + '</span><span class="mcal__year">' + n.y + '</span></div>';
    }
    if (opts.dow) {
      html += '<div class="mcal__dow">';
      DOW.forEach(function (d, i) {
        var label = opts.dow === 'long' ? d : opts.dow === 'short' ? d.slice(0, 3) : opts.dow === 'both'
          ? '<span class="mcal__l">' + d + '</span><span class="mcal__s">' + d.slice(0, 3) + '</span>' : d.charAt(0);
        html += '<span' + (i >= 5 ? ' class="is-we"' : '') + '>' + label + '</span>';
      });
      html += '</div>';
    }
    html += '<div class="mcal__days">';
    cells.forEach(function (c) {
      var cls = 'mcal__d' + (c.inMonth ? '' : ' is-out') + (c.weekend ? ' is-we' : '') + (c.holiday ? ' is-hol' : '');
      html += '<span class="' + cls + '"' + (c.inMonth ? ' data-day="' + c.day + '"' : '') +
        (c.holiday ? ' title="' + esc(c.holiday) + '"' : '') + '><b>' + c.day + '</b>' +
        (c.holiday && opts.names ? '<i>' + esc(c.holiday) + '</i>' : '') + '</span>';
    });
    html += '</div></div>';
    return html;
  }

  /*
    GSAP + ScrollTrigger arrive as deferred theme assets, so they are ready by
    DOMContentLoaded. A section added live in the theme editor can run before
    anything loaded them, so fall back to injecting the URLs the section passed in.
  */
  var libUrls = null, libWaiters = null;
  function setLibs(urls) { if (!libUrls && urls) libUrls = urls; }
  function libsReady() { return window.gsap && window.ScrollTrigger; }
  function whenLibs(cb) {
    if (libsReady()) return cb(window.gsap, window.ScrollTrigger);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { whenLibs(cb); }, { once: true });
      return;
    }
    if (libWaiters) { libWaiters.push(cb); return; }
    if (!libUrls) return;
    libWaiters = [cb];
    var queue = [];
    if (!window.gsap) queue.push(libUrls.gsap);
    if (!window.ScrollTrigger) queue.push(libUrls.st);
    (function next() {
      var src = queue.shift();
      if (!src) {
        var waiting = libWaiters; libWaiters = null;
        if (libsReady()) waiting.forEach(function (f) { f(window.gsap, window.ScrollTrigger); });
        return;
      }
      var el = document.createElement('script');
      el.src = src; el.onload = next; el.onerror = next;
      document.head.appendChild(el);
    })();
  }

  // Wrap each word in a mask so it can rise into view. Returns the inner spans.
  function splitWords(el) {
    if (!el || el.__calSplit) return el ? el.__calSplit : [];
    var words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = words.map(function (w) {
      return '<span class="cal-w" aria-hidden="true"><span class="cal-wi">' + esc(w) + '</span></span>';
    }).join(' ');
    el.__calSplit = Array.prototype.slice.call(el.querySelectorAll('.cal-wi'));
    return el.__calSplit;
  }

  function reduced() {
    return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Shopify section lifecycle: run init on load and in the theme editor, destroy on unload.
  function mount(sectionId, init, destroy) {
    function boot() { destroy(sectionId); init(sectionId); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    document.addEventListener('shopify:section:load', function (e) { if (e.detail && e.detail.sectionId === sectionId) boot(); });
    document.addEventListener('shopify:section:unload', function (e) { if (e.detail && e.detail.sectionId === sectionId) destroy(sectionId); });
  }

  // Height of Horizon's header when it is set to stay stuck to the top, so pinned
  // sections can start underneath it instead of behind it.
  function headerOffset() {
    var h = document.querySelector('header-component');
    if (!h || h.getAttribute('sticky') !== 'always') return 0;
    var box = h.closest('.shopify-section') || h;
    return Math.round(box.getBoundingClientRect().height);
  }

  // ScrollTrigger measures before late images and fonts arrive; refresh once they do.
  var refreshQueued = false;
  function queueRefresh() {
    if (refreshQueued || !window.ScrollTrigger) return;
    refreshQueued = true;
    requestAnimationFrame(function () { refreshQueued = false; window.ScrollTrigger.refresh(); });
  }
  if (!window.__calLoadRefresh) {
    window.__calLoadRefresh = true;
    window.addEventListener('load', queueRefresh);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueRefresh);
  }

  window.MomentoCal = {
    MONTHS: MONTHS,
    DOW: DOW,
    easter: easter,
    holidays: holidays,
    holidayOn: holidayOn,
    monthCells: monthCells,
    gridHTML: gridHTML,
    normalise: normalise,
    whenLibs: whenLibs,
    setLibs: setLibs,
    splitWords: splitWords,
    reduced: reduced,
    mount: mount,
    headerOffset: headerOffset,
    refresh: queueRefresh
  };
})();
